import axios from 'axios'

// Search owns its error states. A separate client avoids the shared interceptor,
// which handles authentication redirects and consumes failed responses.
export default axios.create({
	baseURL: process.env.VUE_APP_API_URL || '/api',
	timeout: 15000,
	withCredentials: true,
	headers: { Accept: 'application/json' },
})
